import React, { FC } from 'react';
import { useFeatureFlag } from '@olx/react-laquesis';
import HeaderValueList from '../../../../commons/components/HeaderValueList';
import { ReturnOrderInfo } from '../../../../../typings/returns';
import useI18n from '../../../../i18n/hooks/useI18n';
import makePrice from '../../utils/makePrice';
import getHeaderKey from '../../utils/getHeaderKey';
import { USER_TYPE } from '../../constants';

interface BuyerPaymentDetailsProps {
  orderInfo: ReturnOrderInfo;
}

const BuyerPaymentDetails: FC<BuyerPaymentDetailsProps> = ({ orderInfo }) => {
  const i18n = useI18n();
  const isBTRRebrandingFlagOn = !!useFeatureFlag('DE-2170');

  const componentsPrices = orderInfo.price.components;
  const totalPrice = orderInfo.price.total;
  const price = makePrice('pl-PL');

  const componentsPricesList = componentsPrices.map(({ code, value }) => ({
    header: getHeaderKey(i18n, code, USER_TYPE.BUYER, isBTRRebrandingFlagOn),
    value: price.parseAndFormat(value.amount, value.currency),
  }));

  const pricesList = [
    ...componentsPricesList,
    {
      header: getHeaderKey(i18n, totalPrice.code, USER_TYPE.BUYER),
      value: price.parseAndFormat(totalPrice.value.amount, totalPrice.value.currency),
      isImportant: true,
    },
  ];

  return <HeaderValueList listItems={pricesList} />;
};
export default BuyerPaymentDetails;
